module.exports = __webpack_public_path__ + "static/media/pointy-sword.bd82b38d.svg";